<template>
  <v-container>
    <v-row>
      <v-col>
        <TablePicker
          title="Data Table"
          v-model="value.table"
          :required="true"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ColumnValueListEditor
          title="Insert Values"
          :table="value.table"
          :field-table="table"
          v-model="value.values"
          :component="component"
          :containers="containers"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <DataOutputPicker title="Save output to" v-model="value.output" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TablePicker from "../shared/TablePicker.vue";
import ColumnValueListEditor from "../shared/ColumnValueListEditor.vue";
import DataOutputPicker from "../shared/DataOutputPicker.vue";

export default {
  name: "InsertDataDesigner",

  components: { TablePicker, ColumnValueListEditor, DataOutputPicker },

  props: ["value", "containers", "table", "component"],
};
</script>
